import translations from "translations"
import * as I18n from "services/i18n"

export default class LoadServices
  @init: ->
    console.log('lis')
    @add_listeners()

  @add_listeners: ->
    $(document).on 'click', '.load-services-btn', (e) =>
      console.log('how')
      e.preventDefault()
      button = $(e.currentTarget)
      stepId = button.data('step-id')
      isLoaded = button.data('loaded')

      if isLoaded
        @toggle_services_visibility(stepId, button)
      else
        @load_step_services(stepId, button)

  @load_step_services: (stepId, button) ->
    container = $("#services-container-#{stepId}")
    container.show()

    $.ajax
      url: "/atividades/load_step_services"
      method: 'GET'
      data: { step_id: stepId }
      beforeSend: ->
        button.prop('disabled', true)
      success: (data) =>
        container.html(data)
        button.data('loaded', true)
        @update_button_text(button, 'hide')
        button.prop('disabled', false)
      error: ->
        container.hide()
        button.prop('disabled', false)
        alert('Erro ao carregar serviços')

  @toggle_services_visibility: (stepId, button) ->
    container = $("#services-container-#{stepId}")

    if container.is(':visible')
      container.hide()
      @update_button_text(button, 'show')
    else
      container.show()
      @update_button_text(button, 'hide')

  @update_button_text: (button, action) ->
    icon = button.find('.load-services-icon')
    text = button.find('.load-services-title')

    if action == 'hide'
      icon.css({
        transform: 'rotate(180deg)'
      })
      text.text(I18n.t(translations(), 'atividades.index.actions.hide_services'))
    else
      icon.css({
        transform: 'rotate(0deg)'
      })
      text.text(I18n.t(translations(), 'atividades.index.actions.load_services'))
